import React from 'react';
import { Section } from './ui/Section';
import { Quote } from 'lucide-react';
export function TestimonialSection() {
  return <Section className="bg-transparent text-center" data-id="element-194">
      <div className="max-w-3xl mx-auto relative p-8 md:p-12 bg-black/50 backdrop-blur-md rounded-3xl border border-[#D4AF37]/20 shadow-2xl" data-id="element-195">
        <Quote className="w-16 h-16 text-[#D4AF37]/40 absolute -top-6 left-4 md:left-8" data-id="element-196" />

        <blockquote className="relative z-10" data-id="element-197">
          <p className="text-2xl md:text-4xl font-serif italic text-white leading-relaxed mb-8 drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]" data-id="element-198">
            "Después de aplicar el Sistema Anticaos™, finalmente logré mantener
            mi rutina de ejercicios por 90 días seguidos."
          </p>
          <footer className="text-[#D4AF37] font-bold tracking-wide uppercase text-sm" data-id="element-199">
            — Cliente Satisfecho
          </footer>
        </blockquote>
      </div>
    </Section>;
}